export default __webpack_public_path__ + "static/poly-38fedf88af471a9bfc96a9e04dc5c162.png";